var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"no-campaign text-3xl font-semibold"},[_c('div',{staticClass:"desc-no-campaign text-dark-gray text-desc-no-campaign"},[_c('CountDown')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }